import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

/**
 * CreatorPage - 已废弃
 * 此组件现在重定向到统一的用户个人主页 UserProfilePage
 */
const CreatorPage = () => {
  const { creatorId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    // 重定向到统一的用户个人主页
    navigate(`/profile/${creatorId}`, { replace: true });
  }, [creatorId, navigate]);

  return null;
};

export default CreatorPage;
